export function getStoreLogoBaseName(storeName: string) {
  return storeName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function getStoreLogoAlt(storeSlug: string) {
  return getStoreLogoBaseName(storeSlug) || "store";
}

export function getStoreLogoFileName(storeName: string, originalFileName: string, uniqueSuffix?: string) {
  const extension = originalFileName.match(/\.[a-z0-9]{1,8}$/i)?.[0].toLowerCase() || ".png";
  const suffix = uniqueSuffix ? `-${getStoreLogoBaseName(uniqueSuffix)}` : "";
  return `${getStoreLogoBaseName(storeName) || "store"}-coupon-code-itscoupons${suffix}${extension}`;
}